import "es6-shim";
import Vue from "vue";
import vueHeadful from "vue-headful";
import VueConfig from "vue-configuration";
import appSettings from "./settings";
import VueI18N from "vue-i18n";
import App from "./App";
import { sync } from "vuex-router-sync";
import router from "./router/index";
import RouterEvent from "./router/RouterEvent";
import moment from "moment";
import { store } from "./state/store";
import listener from "./state/listener";
import myIp from "quick-local-ip";
import nprogress from "nprogress";
import { apiEmitter, EXPIRED_TICKED } from "redbay-b2b-api/src/ApiClient";
import VueCarousel from "vue-carousel";
import BootstrapVue from "bootstrap-vue";

Vue.use(BootstrapVue);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-material-design-icons/styles.css";
import "font-awesome/scss/font-awesome.scss";
import "./assets/style/main.scss";
import Notifications from "vue-notification";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";

Vue.use(Croppa);
Vue.config.productionTip = false;
Vue.use(VueI18N);
Vue.use(VueConfig, { config: appSettings });
Vue.use(Notifications);
moment.locale("pl");

Vue.use(VueCarousel);
Vue.component("vue-headful", vueHeadful);

sync(store, router);

listener.init();

const AppUi = function(el) {
  return {
    el,
    store,
    router,
    render: h => h(App)
  };
};

router.beforeEach(async (to, from, next) => {
  console.log("createTicket");
  await store.dispatch("createTicket", {
    ip: myIp.getLocalIP4(),
    domain: appSettings.application.domain,
    referer: document.referrer,
    browser: navigator.userAgent,
    AppId: "NEW IPH",
    language: "pl",
    currency: "PLN",
    expireTicket: appSettings.application.expireTimeTicket
  });
  RouterEvent.beforeEach(to, from, next, store.state);
});

document.addEventListener("DOMContentLoaded", async () => {
  const element = document.getElementById("app");

  try {
    new Vue(AppUi(element));
  } catch (e) {
    console.log(e);
  }
});

apiEmitter.on(EXPIRED_TICKED, () => {
  console.log("expired ticked");
  store.dispatch("clearTicket");
  if (!window.location.href.endsWith("restorepassword")) {
    router.replace({ name: "mainPage" });
  }
});



// WEBPACK FOOTER //
// ./src/main.js